/* eslint-disable camelcase */
import React from 'react';
import { RichText } from 'prismic-reactjs';
import Carousel from 'react-multi-carousel';
import { IPrismicImage, IPrismicText } from '@lib/prismic/types';
import Navigator from '@components/shared/Navigator/Navigator';
import { useTheme } from '@components/theme';

import styles from './HowWeHire.module.scss';

interface IHowWeHireProps {
    description: string;
    image: IPrismicImage;
    steps: IHowWeHireSteps[];
    title: string;
}

export interface IHowWeHireSteps {
    step_text: IPrismicText[];
    step_title: IPrismicText[];
}

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1100 },
    items: 1,
    partialVisibilityGutter: 0,
    slidesToSlide: 1,
  }
};

const HowWeHire = ({
  description,
  image,
  steps,
  title,
}: IHowWeHireProps) => {
  const theme = useTheme();
  return (
    <div className={styles.ContainerWrapper}>
      <div className={styles.Container}>
        <h2 className={theme.styles.Header}>{title}</h2>
        <p className={theme.styles.Body}>
          {description}
        </p>
        <div className={styles.StepMobile}>
          {
            steps.map(({ step_text, step_title }: IHowWeHireSteps) => {
              const stepTitle = RichText.asText(step_title);
              return (
                <div key={stepTitle} className={styles.Step}>
                  <h3 className={theme.styles.Title1}>{stepTitle}</h3>
                  <span>{RichText.asText(step_text)}</span>
                </div>
              );
            })
            }
        </div>
        <Carousel
          arrows={false}
          className={styles.StepDesktop}
          responsive={responsive}
          customButtonGroup={<Navigator className={styles.Navigator} />}
          showDots
          renderButtonGroupOutside
          renderDotsOutside
        >
          {
            steps.map(({ step_text, step_title }: IHowWeHireSteps) => {
              const stepTitle = RichText.asText(step_title);
              return (
                <div key={stepTitle} className={styles.Step}>
                  <h3 className={theme.styles.Title1}>{stepTitle}</h3>
                  <span>{RichText.asText(step_text)}</span>
                </div>
              );
            })
            }
        </Carousel>
      </div>
      <div className={styles.Image} style={{ backgroundImage: `url(${image.url})` }} />
    </div>
  );
};

export default HowWeHire;
